module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-icon-8bbdfbfb6ca5a8a114526985de0c4a75.svg";